import styled, { css } from 'styled-components';

import ArrowButton from 'Elements/Button/Arrow';
import { ReactComponent as WaveSVG } from 'Public/graphics/waves/open-days/contact.svg';

export const Container = styled.section`
    ${({ theme }) => css`
        background: ${theme.colors.secondary.tints[1].hex};
        position: relative;
        overflow-x: clip;
        clip-path: inset(0 0 -50rem -50rem);
    `}
`;

export const Inner = styled.div`
    ${({ theme }) => css`
        margin: 2rem 0;
        background: rgba(${theme.colors.secondary.tints[1].rgb}, 0.6);

        @media ${theme.breakpoints.medium.media} {
            margin: 3rem 0;
            padding: 0.5rem;
            border: 0.1rem solid ${theme.colors.primaryContrast.hex};
            border-radius: 0.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            margin: 5rem 0;
            padding: 1.5rem 2rem;
        }
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        margin: 0 0 0.5rem;
        font-size: 2rem;
        line-height: 1.3;

        @media ${theme.breakpoints.large.media} {
            margin: 0 0 2rem;
            font-size: 3rem;
        }
    `}
`;

export const Overview = styled.div`
    ${({ theme }) => css`
        margin-bottom: 1.5rem;

        @media ${theme.breakpoints.medium.media} {
            margin-bottom: 0;
            margin-top: 0.75rem;
        }
    `}
`;

export const OverviewText = styled.div`
    margin: 0 0 2rem;

    p:first-of-type {
        margin-top: 0;
    }
`;

export const ArrowButtonTablet = styled(ArrowButton)`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.medium.media} {
            display: inline-flex;
        }
    `}
`;

export const ArrowButtonMobile = styled(ArrowButton)`
    ${({ theme }) => css`
        margin-top: 1.5rem;

        @media ${theme.breakpoints.medium.media} {
            display: none;
        }
    `}
`;

export const Wave = styled(WaveSVG)`
    ${({ theme }) => css`
        position: absolute;
        z-index: -1;
        transform: rotate(50deg);
        transform-origin: center;
        width: 125rem;
        height: 185rem;
        bottom: -88rem;
        left: -58rem;

        @media ${theme.breakpoints.medium.media} {
            transform: none;
            bottom: auto;
            width: 425rem;
            height: 86rem;
            top: -19rem;
            left: -255rem;
        }
    `}
`;
